module.exports = __webpack_public_path__ + "static/media/knife_hit.127dcc4e.jpg";